import React from 'react';
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";

import { FormInputCheckbox } from "../../../ReactHookForm/FormComponents";
import {useSessionContext} from "root/Contexts/SessionContext";

const HookSubFormPupilPremium = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const { loggedOnUserIsTeacher } = useSessionContext() ;

    const preventChanges = readOnly || loggedOnUserIsTeacher ;

    return (
        <FieldsetContainer title='Pupil Premium Plus' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputCheckbox readOnly={preventChanges} label='Is the pupil eligible for Pupil Premium Plus Payments?' sectionName={sectionName} name={'pp_plus'} register={register}/>
                </BootstrapCol>
            </BootstrapRow>
        </FieldsetContainer>
    )
}


export default HookSubFormPupilPremium;
